import { ReactNode, MouseEvent } from "react";
import { createPortal } from "react-dom";
import styles from "./style.module.scss";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";

type ConfirmModalProps = {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  onConfirm?: (e: MouseEvent<HTMLButtonElement>) => void;
  onCancel?: (e: MouseEvent<HTMLButtonElement>) => void;
  primaryBtn?: string;
  primaryBtnColor?: string;
  secondaryBtn?: string;
  secondaryBtnColor?: string;
  children?: ReactNode;
  /** `data-testid` del modal; los botones reciben `${testId}-confirm` y `${testId}-cancel`. */
  testId?: string;
};

const ConfirmModal = ({
  onConfirm,
  onCancel,
  isOpen,
  toggle,
  title,
  primaryBtn = "Aceptar",
  primaryBtnColor = "primary",
  secondaryBtn = "Cancelar",
  secondaryBtnColor = "danger",
  children,
  testId
}: ConfirmModalProps) => {

  const triggerOnConfirm = (e: MouseEvent<HTMLButtonElement>) => {
    if (onConfirm) {
      onConfirm(e);
    }
  }

  const triggerOnCancel = (e: MouseEvent<HTMLButtonElement>) => {
    if (onCancel) {
      onCancel(e);
    } else if (toggle) {
      toggle()
    }
  }

  return isOpen && createPortal(
    <Modal
      className={styles.modal}
      toggle={toggle}
      isOpen={isOpen}
      data-testid={testId}>
      {title && <ModalHeader toggle={toggle}>{title}</ModalHeader>}
      <ModalBody>{children}</ModalBody>
      <ModalFooter>
        <Button color={primaryBtnColor} onClick={triggerOnConfirm} data-testid={testId && `${testId}-confirm`}>
          {primaryBtn}
        </Button>
        <Button color={secondaryBtnColor} onClick={triggerOnCancel} data-testid={testId && `${testId}-cancel`}>
          {secondaryBtn}
        </Button>
      </ModalFooter>
    </Modal>,
    document.body
  );
};

export default ConfirmModal;
